import React from 'react';
import { Button, WorkStoryBlackLogo } from 'src/components';

const Maintenance = () => (
  <div className='w-full h-screen flex flex-col justify-center items-center py-16 px-6 md:px-0'>
    <WorkStoryBlackLogo />
    <div className='m-auto md:w-1/4'>
      <p className='font-bold text-2xl text-black'>We'll be back soon!</p>
      <p className='mb-2'>
        WorkStory is undergoing maintenance. We expect to be back online in a
        few minutes.
      </p>
      <p className='mt-0'>
        In the meantime, check out some of our free resources to find
        inspiration on how to get the most out of your performance management
        process.
      </p>
      <Button
        variant='black'
        onClick={() => window.open('https://www.workstory.team/#free-resources', '_blank')}
      >
        See Resources
      </Button>
    </div>
  </div>
);

export default Maintenance;
